let scriptLoaded = false;
const callback = function () {
    if (scriptLoaded) {
        return;
    }
    scriptLoaded = true;

    var tk = '3382253e2ed5458418a740743b53b9ddc93f35e5d42b0fd0746a20adf077', rd = 100, dm = window.location.hostname, spm = document.createElement('script');
    spm.src = 'https://pm.scalecommerce.cloud/scripts/main@1.0.0/core.min.js?token=' + tk + '&samplingRate=' + rd + '&domain=' + dm;
    spm.async = true;
    spm.onload = function () {
        window.initM(tk, rd, dm)
    };
    document.head.appendChild(spm)
}

const cookieConsentGroupAnalyse = document.cookie.split(';').find(c => c.trim().startsWith('cookie_consent_group_analyse'));
if (cookieConsentGroupAnalyse && cookieConsentGroupAnalyse.endsWith('1')) {
    callback();
} else {
    window.addEventListener('load', (event) => {
        if (window?.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) {
            callback();
        } else {
            document.addEventListener("visitorConsentCollected", ({detail}) => {
                if (detail && detail?.analyticsAllowed) {
                    callback();
                }
            });
        }
    });
}